import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';

const FreeShippingBar = ({total, freeShippingBarSettings}) => {
  const {
    remainingTemplate,
    twoRemainingTemplate,
    oneRemainingTemplate,
    reachedTemplate,
    serviceOne,
    serviceTwo,
    thresholdOne,
    thresholdTwo,
    linkOne,
    linkTwo,
  } = freeShippingBarSettings;

  /**
   * Create the free shipping remaining spend message.
   */
  const createRemainingMessage = () => {
    if (total < thresholdOne) {
      const remainingOne = formatMoney(thresholdOne - total, window.theme.moneyFormat);
      const remainingTwo = thresholdTwo ? formatMoney(thresholdTwo - total, window.theme.moneyFormat) : null;
      const message = remainingTwo
        ? twoRemainingTemplate
            .replace('{{ service_1 }}', linkOne ? `<a href="${linkOne}">${serviceOne}</a>` : serviceOne)
            .replace('{{ service_2 }}', linkTwo ? `<a href="${linkTwo}">${serviceTwo}</a>` : serviceTwo)
            .replace('{{ amount_1 }}', remainingOne)
            .replace('{{ amount_2 }}', remainingTwo)
        : remainingTemplate
            .replace('{{ amount }}', remainingOne)
            .replace('{{ service }}', linkOne ? `<a href="${linkOne}">${serviceOne}</a>` : serviceOne);
      return message;
    }

    if (thresholdTwo && total < thresholdTwo) {
      const remainingTwo = formatMoney(thresholdTwo - total, window.theme.moneyFormat);
      const message = oneRemainingTemplate
        .replace('{{ service_1 }}', linkOne ? `<a href="${linkOne}">${serviceOne}</a>` : serviceOne)
        .replace('{{ service_2 }}', linkTwo ? `<a href="${linkTwo}">${serviceTwo}</a>` : serviceTwo)
        .replace('{{ amount_2 }}', remainingTwo);
      return message;
    }

    const service = thresholdTwo ? serviceTwo : serviceOne;
    const link = thresholdTwo ? linkTwo : linkOne;
    const serviceHTML = link ? `<a href="${link}">${service}</a>` : service;
    const message = reachedTemplate.replace('{{ service }}', serviceHTML);
    return message;
  };

  const barMessage = createRemainingMessage();

  return (
    <div className="side-cart__free-shipping">
      <p className="h7" dangerouslySetInnerHTML={{__html: barMessage}} />
    </div>
  );
};

FreeShippingBar.propTypes = {
  total: PropTypes.number,
  freeShippingBarSettings: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    remainingTemplate: PropTypes.string.isRequired,
    twoRemainingTemplate: PropTypes.string.isRequired,
    oneRemainingTemplate: PropTypes.string.isRequired,
    reachedTemplate: PropTypes.string.isRequired,
    serviceOne: PropTypes.string.isRequired,
    serviceTwo: PropTypes.string,
    thresholdOne: PropTypes.number.isRequired,
    thresholdTwo: PropTypes.number,
    linkOne: PropTypes.string,
    linkTwo: PropTypes.string,
  }),
};

export default FreeShippingBar;
